import { render } from "./Panels.molecules.vue?vue&type=template&id=69bdbb50&scoped=true&bindings={\"handleOnRedirect\":\"setup\"}"
import script from "./Panels.molecules.vue?vue&type=script&lang=ts"
export * from "./Panels.molecules.vue?vue&type=script&lang=ts"

import "./Panels.molecules.vue?vue&type=style&index=0&id=69bdbb50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69bdbb50"

export default script